// extracted by mini-css-extract-plugin
module.exports = {"MiddleCard":"MiddleCard_MiddleCard__Aqd6D"};